import { defineComponent as _defineComponent } from 'vue'
import BCXItemsWithPoints from '@/components/molecules/BCXItemsWithPoints.vue';
import BCXButton from '@/components/molecules/BCXButton.vue';
import { useStore } from 'vue2-helpers/vuex';
import { computed } from 'vue';
import Reporting from '@/components/voting/Reporting.vue';
import useUser from '@/mixins/useUser';
import useResponsiveness from '@/mixins/useResponsiveness';


export default /*#__PURE__*/_defineComponent({
  __name: 'ProjectActionsButtons',
  props: {
  isAlignedRight: Boolean,
  isJustifiedRight: Boolean,
},
  emits: ['recommend', 'apply'],
  setup(__props) {





const store = useStore();
const project = computed(() => store.state.projectForum.project);
const { tUserFallback: t, isCustomer, isGuest } = useUser('self');

const { isMobileWidth } = useResponsiveness();

const isButtonVisible = computed(() => ({
  recommend: !['CLOSED'].includes(project.value.status) && !isCustomer.value && !isGuest.value,
  apply: !['CLOSED'].includes(project.value.status) && !isCustomer.value && !isGuest.value,
  reply: !['CLOSED'].includes(project.value.status),
  newProject: !isGuest.value,
}));

const toggleCreateMessage = () => {
  store.dispatch('projectForum/triggerCreateMessage');
};


return { __sfc: true,store, project, t, isCustomer, isGuest, isMobileWidth, isButtonVisible, toggleCreateMessage, BCXItemsWithPoints, BCXButton, Reporting }
}

})